module.exports = '<svg width="24" height="32" viewBox="0 0 24 32"><path d="M22 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h20c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-9 30h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zm7-6H4V4h16v20z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/ipad-mini-1.js
// module id = 1195
// module chunks = 14